import * as FS from '@fullstory/browser';

import { RuntimeEnvironmentOptions, getEnvFromHostname } from '@growtherapy/analytics';

export function sendFullStoryEvent(eventName: string, eventProperties: object = {}) {
  if (
    FS.isInitialized() &&
    getEnvFromHostname({ hostname: location.hostname }) === RuntimeEnvironmentOptions.production
  ) {
    FS.event(eventName, eventProperties);
  }
}
